import type * as React from "react"

import { cn } from "@/lib/utils"

export function FormCapsLabel(
  props: React.HTMLAttributes<HTMLSpanElement>,
) {
  return (
    <span
      {...props}
      className={cn(
        "uppercase tracking-[0.18em] text-sm font-semibold text-slate-900",
        props.className,
      )}
    />
  )
}

